import React, { useEffect } from 'react';

export default function StockfishBridge() {
  useEffect(() => {
    const engine = new Worker("/stockfish-nnue-16-single.js");

    engine.onmessage = function (event) {
      const message = typeof event === 'object' ? event.data : event;
      window.ReactNativeWebView?.postMessage("📩 Engine says: " + message);
    };

    window.addEventListener("message", (event) => {
      if (typeof event.data === "string") {
        engine.postMessage(event.data);
      }
    });

    window.ReactNativeWebView?.postMessage("✅ StockfishBridge Ready");

    return () => engine.terminate();
  }, []);

  return <div>StockfishBridge is running...</div>;
}